/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { OrganizationDetailsAppLayout as ServicedeskOrganizationDetailsType } from '@jira/spa-apps__servicedesk-organization-details/src/OrganizationDetailsAppLayout.tsx';
import type { OrganizationsAppLayout as ServicedeskOrganizationsType } from '@jira/spa-apps__servicedesk-organizations/src/OrganizationsAppLayout.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskOrganizations: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskOrganizationsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-organizations", jiraSpaEntry: "async-servicedesk-organizations" */ '@jira/spa-apps__servicedesk-organizations/src/ServicedeskOrganizations.tsx'
		),
	),
);

export const ServiceDeskOrganizations = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskOrganizations}
		pageId="spa-apps/servicedesk/organizations"
		shouldShowSpinner
	/>
);

export const LazyServicedeskOrganizationDetails: LazyComponent<React.FC<{}>> = lazyForPaint<
	typeof ServicedeskOrganizationDetailsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-organization-details", jiraSpaEntry: "async-servicedesk-organization-details" */ '@jira/spa-apps__servicedesk-organization-details/src/ServicedeskOrganizationDetails.tsx'
		),
	),
);

export const ServicedeskOrganizationDetails = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskOrganizationDetails}
		pageId="spa-apps/servicedesk/organization-details"
		shouldShowSpinner
	/>
);
